<template>
  <div>
    <!-- header buttons -->
    <div v-if="true" style="display: flex; justify-content: space-between">
      <v-btn fab depressed color="black" dark small :to="`/regalos/campaign/${campaign_id}/idea/${idea_id}`"
        ><v-icon>mdi-close</v-icon></v-btn
      >
      <v-btn fab depressed color="success" dark small @click="save"><v-icon>mdi-check</v-icon></v-btn>
    </div>

    <h1>Editar idea</h1>

    <v-text-field v-model="idea.title" label="title" outlined></v-text-field>
    <v-text-field v-model="idea.description" label="description" outlined></v-text-field>
    <div v-if="loading">Loading...</div>

    <!-- if only one idea, we can edit it here for now -->
    <div v-if="idea.options && idea.options.length == 1">
      <b>Opción 1</b>
      <v-text-field outlined v-model="idea.options[0].link" label="link"></v-text-field>
      <v-text-field outlined v-model="idea.options[0].price" label="price"></v-text-field>
      <v-text-field outlined v-model="idea.options[0].title" label="title"></v-text-field>
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'
export default {
  props: {
    campaign_id: {
      type: String,
      default: '',
    },
    idea_id: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      campaign: {},
      idea: {},
    }
  },
  methods: {
    async save() {
      if (!this.idea.campaign_id) this.idea.campaign_id = this.campaign_id
      let x = await api.apiFetch(`/regalos/idea`, {
        method: 'POST',
        body: JSON.stringify(this.idea),
      })
      if (!x.ok) return alert('something failed')
      this.idea = await x.json()
      this.$router.push(`/regalos/campaign/${this.campaign_id}/idea/${this.idea_id}`)
    },
    async fetchData() {
      this.loading = true
      let x = await api.apiFetch(`/regalos/campaign?id=${this.campaign_id}`)
      this.loading = false
      if (!x.ok) return alert('something failed')
      let j = await x.json()
      this.campaign = j

      if (!j.ideas) j.ideas = []
      const idea = j.ideas.find((i) => i.id == this.idea_id)
      if (!idea) return alert('idea not found')
      this.idea = idea
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
